import Table from '@oncolens/oncolens-ui/lib/components/Common/Table';
import React from 'react';
// eslint-disable-next-line import/no-extraneous-dependencies
import { useNavigate } from 'react-router';
import { BehaviorConfigDto, getBehaviorConfigs } from '../api/behavior-configs';
import OrganizationColumn from './OrganizationColumn';

interface Props {
  searchQuery: string;
}

const BehaviorConfigTable = ({ searchQuery }: Props) => {
  const columns = React.useMemo(
    () => [
      { accessor: 'id', Header: 'Id' },
      { accessor: 'organization', Header: 'Organization', Cell: BehaviorConfigOrganizationColumn },
      {
        accessor: 'displayPages',
        Header: 'Display Pages',
        Cell: DisplayPagesColumn,
      },
      { accessor: 'type', Header: 'Type' },
      { accessor: 'status', Header: 'Status' },
      { accessor: 'groupRefCode', Header: 'Group Ref Code' },
    ],
    [],
  );

  const filters = {
    ...(searchQuery && { Filters: `(ReferenceKey|GroupRefCode)@=*${searchQuery}` }),
  };

  const navigate = useNavigate();
  const navigateToEdit = (rowData: any) => navigate(rowData.id);

  return (
    <Table
      columns={columns}
      onRowClick={navigateToEdit}
      fetchData={getBehaviorConfigs}
      queryBaseKey="behaviorConfigs"
      additionalQueryParameters={filters}
      options={{ textSize: 'sm' }}
    />
  );
};

interface BehaviorConfigTableRowProps {
  row: {
    original: BehaviorConfigDto;
  };
}

const BehaviorConfigOrganizationColumn = ({ row }: BehaviorConfigTableRowProps) => (
  <OrganizationColumn row={row} />
);

const DisplayPagesColumn = ({ row: { original: rowData } }: BehaviorConfigTableRowProps) => (
  <div className="flex flex-col space-y-1">
    {rowData.displayPages.map((displayPage) => (
      <span key={displayPage}>{displayPage}</span>
    ))}
  </div>
);

export { BehaviorConfigTable as default };
